import React from 'react';
import PropTypes from 'prop-types';

export default class Divider extends React.Component {

	getType() {
		return `type-${this.props.type}`
	}

	render() {
		let type = this.getType();
		let hide = !this.props.isVisible ? 'hide' : '';

		return (
			<div className={`col s12 ${hide}`}>
				<div className={`divider ${type}`}></div>
			</div>
		);
	}
}

Divider.protoTypes = {
	type: PropTypes.oneOf(['simple', 'double', 'separator'])
}

Divider.defaultProps = {
	type: 'simple'
}
